import baseConfig from './config.base'

export default {
  ...baseConfig,
  resetAppTimeOut: 0, // disable app reset
  errorWidgetTimeOut: 0, // disable app error widget reset
  log2api: false, // disable log to api
  env: 'development',
}
